import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    question: "What types of industries does TAKEOFF serve?",
    answer:
      "We work with ambitious brands across various industries including restaurants, hospitality, retail, e-commerce, professional services, real estate, and more. Our strategies are customized for each client regardless of industry.",
  },
  {
    question: "How long does it take to see results from a digital marketing campaign?",
    answer:
      "While some metrics improve within the first few weeks, substantial results typically emerge within 2-3 months. Social media growth, engagement, and lead generation are ongoing processes that compound over time with consistent effort and optimization.",
  },
  {
    question: "Can TAKEOFF serve both B2B and B2C clients?",
    answer:
      "Absolutely. We have experience working with both B2B and B2C clients. Our strategies are tailored to your specific target audience, whether that's other businesses or direct consumers.",
  },
  {
    question: "What is the process for onboarding new clients?",
    answer:
      "Our onboarding process includes: (1) Discovery call to understand your business and goals, (2) Brand audit and competitive analysis, (3) Strategy development and content calendar creation, (4) Content shoot scheduling, (5) Launch and ongoing optimization.",
  },
  {
    question: "What is your approach to content creation?",
    answer:
      "We handle everything in-house — from strategy and scripting to filming, editing, and posting. Our team creates platform-optimized content including Reels, carousels, stories, and static posts designed to engage your audience and drive results.",
  },
  {
    question: "How do you utilize AI automation in your marketing strategies?",
    answer:
      "We implement AI-powered systems for DM automation, lead capture, email sequences, content repurposing, and workflow optimization. These tools save you hours every week while ensuring no leads slip through the cracks.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-dark">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2
            data-testid="faq-title"
            className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl uppercase text-white"
          >
            Frequently Asked <span className="text-lime">Questions</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                data-testid={`faq-item-${index}`}
                className="border-white/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${index}`}
                  className="font-body text-left text-white hover:text-lime hover:no-underline py-5 text-base"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${index}`}
                  className="font-body text-white/60 pb-5 text-sm leading-relaxed"
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
